// Security utilities and anti-debugging protection
const isDev = () => process.env.NODE_ENV === 'development';

// Anti-debugging protection
export const initSecurityProtection = () => {
  if (isDev()) return;

  // Simplified security protection - only basic measures
  document.addEventListener('contextmenu', (e) => e.preventDefault());
  
  // Disable F12, Ctrl+Shift+I, Ctrl+U, Ctrl+S  
  document.addEventListener('keydown', (e) => {
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && e.key === 'I') ||
      (e.ctrlKey && e.key === 'u') ||
      (e.ctrlKey && e.key === 's') ||
      (e.ctrlKey && e.shiftKey && e.key === 'C')
    ) {
      e.preventDefault();
      return false;
    }
  });

  // Disable text selection and drag
  document.addEventListener('selectstart', (e) => e.preventDefault());
  document.addEventListener('dragstart', (e) => e.preventDefault());
};

// Secure logging that only works in development
export const secureLog = {
  info: (...args: any[]) => isDev() && console.log(...args),
  warn: (...args: any[]) => isDev() && console.warn(...args),
  error: (...args: any[]) => isDev() && console.error(...args),
};

// Obfuscated route mapping
export const routes = {
  auth: '/',
  main: '/dashboard',
  panel: '/admin',
  user: '/profile',
};

// Obfuscated component names mapping
export const components = {
  nav: 'NavHeader',
  dash: 'DataView',
  mgmt: 'UserControl',
  panel: 'AdminView',
};

// Rate limiting for sensitive operations
const rateLimits = new Map<string, { count: number; resetTime: number }>();

export const checkRateLimit = (key: string, maxAttempts: number = 5, windowMs: number = 60000): boolean => {
  const now = Date.now();
  const current = rateLimits.get(key);
  
  if (!current || now > current.resetTime) {
    rateLimits.set(key, { count: 1, resetTime: now + windowMs });
    return true;
  }
  
  if (current.count >= maxAttempts) {
    return false;
  }
  
  current.count++;
  return true;
};

// Environment detection
export const getEnvironment = () => {
  if (isDev()) return 'dev';
  return 'prod';
};

// Anti-tampering check
export const verifyIntegrity = () => {
  if (isDev()) return true;
  
  // Basic integrity checks
  const expectedElements = ['html', 'body', 'head'];
  return expectedElements.every(tag => document.getElementsByTagName(tag).length > 0);
};